import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n'
import {downloadDocument} from '../../util/util'
import actionTypes from '../../constants/actions/importarDireccionesExcel/importarDireccionesExcel'
import {submitImportarDireccionesExcelSuccess} from '../../actions/importarDireccionesExcel/importarDireccionesExcel'
import {openModal, closeModal, openSimpleModal, openMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import getImportarDireccionesExcel from '../../services/importarDireccionesExcel/getImportarDireccionesExcel'
import getDescargarPlantillaExcelDireccionesExcel from '../../services/importarDireccionesExcel/getDescargarPlantillaExcelDireccionesExcel'

export function * submitImportarDireccionesExcel ({value}) {
  try {
    let auth = yield select(state => state.auth)
    const listCargaIndex = yield call(getImportarDireccionesExcel, value, auth.token)    
    yield put(submitImportarDireccionesExcelSuccess(listCargaIndex))
  } catch (error) {
    console.log(error)
  } finally {
    /*yield put(commonActions.hideLoader())*/
  }
}
export function * watchSubmitImportarDireccionesExcel () {
  yield takeLatest(actionTypes.SUBMIT_IMPORTAR_DIRECCIONES_EXCEL, submitImportarDireccionesExcel)
}

export function * descargarPlantillaExcelDireccionesExcel () {
  try {
    const archivoExcel = yield call(getDescargarPlantillaExcelDireccionesExcel, null)
    let href = 'data:application/csv;base64,' + encodeURIComponent(archivoExcel.xls)
    let name = i18n.t('IMPORTAR_DIRECCIONES_EXCEL.EJEMPLO_EXCEL_DIRECCIONES') + ".xlsx"
    downloadDocument(href, name)
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchDescargarPlantillaExcelDireccionesExcel () {
  yield takeLatest(actionTypes.DESCARGAR_PLANTILLA_EXCEL_DIRECCIONES_EXCEL, descargarPlantillaExcelDireccionesExcel)
}